/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSsmCommandPlugin {
    getFixupPrototypeFunction() { return AwsSsmCommandPlugin.fixupPrototype; }

    static newInstance(model: Partial<AwsSsmCommandPlugin>): AwsSsmCommandPlugin {
        let obj = Object.assign(new AwsSsmCommandPlugin(), model);
        AwsSsmCommandPlugin.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSsmCommandPlugin>): AwsSsmCommandPlugin {
        if (!model) return null;
        return AwsSsmCommandPlugin.newInstance(<AwsSsmCommandPlugin> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSsmCommandPlugin) {
        if (!obj) return;

        models.AwsSsmCommandPlugin.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSsmCommandPlugin): boolean {
        Object.setPrototypeOf(obj, AwsSsmCommandPlugin.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.response_code === undefined) {
            this.response_code = 0;
        }
        if (typeof this.response_start_date_time === "string") {
            this.response_start_date_time = new Date(<string><any>this.response_start_date_time);
        }
        if (typeof this.response_finish_date_time === "string") {
            this.response_finish_date_time = new Date(<string><any>this.response_finish_date_time);
        }
    }

    /**
     * Name of the plugin
     */
    name: string;

    /**
     * Status of the Execution
     */
    status: models.AwsSsmCommandExecutionStatus;

    /**
     * Detailed status of the execution
     */
    status_details: string;

    /**
     * Response code of the plug in
     */
    response_code: number;

    response_start_date_time: Date;

    response_finish_date_time: Date;

    /**
     * Output of the execution
     */
    output: string;

    /**
     * Name of the plugin
     */
    plugin_name: string;

    /**
     * standard output parameters
     */
    standard_output_contents: string;

    /**
     * standard url of the output
     */
    standard_output_url: string;

    /**
     * standard error contents of the output.
     */
    standard_error_content: string;

    /**
     * standard url of the error content
     */
    standard_error_url: string;

}
